import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import moment from 'moment'

Vue.config.productionTip = false

// Buefy
import Buefy from 'buefy'

// Import SCSS
import './assets/sass/bulma.scss'
import './assets/sass/main.scss'
import './assets/sass/fonts.scss'
import './assets/sass/spacing.scss'

import 'font-awesome/css/font-awesome.min.css';

// Define the base api url
Vue.prototype.BACKEND_BASE_URL = process.env.VUE_APP_BACKEND_BASE_URL
Vue.prototype.APP_BASE_URL = process.env.VUE_APP_BASE_URL

axios.defaults.baseURL = process.env.VUE_APP_API_URL

Vue.use(Buefy)

Vue.filter('formatDate', (value: string) => {
    if (value) {
        return moment(String(value)).format('DD.MM.YYYY')
    }
})

Vue.filter('formatLongDate', (value: string) => {
    if (value) {
        return moment(String(value)).format('dddd, DD. MMMM YYYY')
    }
})


Vue.filter('formatDateTime', (value: string) => {
    if (value) {
        return moment(String(value)).format('DD.MM.YYYY, HH:ss')
    }
})


new Vue({
    router,
    render: (h) => h(App),
}).$mount('#app')
